import React from 'react';
import { ColumnViewController as New } from './ColumnViewController';
import {
  convertOldColumnViewControllerProps,
  OldColumnViewControllerProps,
  OldTableColumnViewType,
} from './converter.old';

export type TableColumnViewType<T> = OldTableColumnViewType<T>;
export type ColumnViewControllerProps<T> = OldColumnViewControllerProps<T>;
export const ColumnViewController = <T,>(props: React.PropsWithChildren<ColumnViewControllerProps<T>>): JSX.Element => (
  <New {...convertOldColumnViewControllerProps(props)} />
);

ColumnViewController.displayName = 'ColumnViewController';
